import { IHttpClient } from '@wix/yoshi-flow-editor';
import type { ErrorMonitor } from '@wix/fe-essentials-viewer-platform/error-monitor';

export function fetchUserId(
  httpClient: IHttpClient,
  errorMonitor: ErrorMonitor,
): Promise<{ success: boolean }> {
  return httpClient
    .get<{ success: boolean }>(
      'https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails',
    )
    .then((response) => response.data)
    .catch((e) => {
      errorMonitor.captureException(e);
      return { success: false };
    });
}
